import { downloadFile } from "@nens/shared-utils";

import { useFileDownloadQueryDirectly } from "@/queries/query-file-download";
import { ProjectFile } from "@/types/api-model-simple-names";
import { getNameFromFileId } from "@/utils/get-name-from-file-id";

const delay = async () => await new Promise((resolve) => setTimeout(resolve, 500));

// FUTURE: remove this function when there is an API endpoint available for downloading multiple files in 1 zip file
// EXPLANATION
// download files sequentially instead of in parallel
// browser security restrictions often prevent multiple simultaneous downloads
// So download one file, wait a bit, then download the next file
export const downloadMultipleFiles = async (
  filesList: ProjectFile[],
  fileDownloadQueryDirectly: ReturnType<typeof useFileDownloadQueryDirectly>
) => {
  for (const file of filesList) {
    // Project files do not contain a download url directly so we need to query for it first
    const { isSuccess, data: downloadUrl } = await fileDownloadQueryDirectly(file);
    if (isSuccess) downloadFile(downloadUrl, getNameFromFileId(file.id));
    await delay();
  }
};

// Publication files contain a download url directly
// so no need to query for it first
// The wide type is that it works for old and new publications
export const downloadMultipleFileReferences = async (
  fileReferences: { file: { url: string; id: string } }[]
) => {
  for (const { file } of fileReferences) {
    downloadFile(file.url, getNameFromFileId(file.id));
    await delay();
  }
};
